import { Config } from "src/modules/app-template/models/config.model";

export const environment: Partial<Config> = {
    pageTitle: "Michaelshof Portal",
    backendUrl: "",
    activeModules: ["EnaioPayrollModule"],
	staticHeaderHtml: "<a href=\"https://ahg-digital.haufe.de/uuid/bb9460bb-ba54-4c12-b25b-25d618425e8d\" class=\"primary-color ml-8\"><u>Aushangpflichtige Gesetze Digital</u></a>"    
};